import React from 'react';
import { TextField, IconButton, Autocomplete } from '@mui/material'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { useNavigate } from 'react-router-dom';
import SimpleWhiteBox from './SimpleWhiteBox';

export default function HomeSearch(props) {
  const [value, setValue] = React.useState(props.dfSearch)

  const navigate = useNavigate()

  const handleSearch = (event)=>{
    event.preventDefault()
    if(event.target[0].value.length > 0)
      navigate('/search/' + event.target[0].value)
  }

  const handleChangeValue = (v) => {
    setValue(v.target.value)
  }

  return (
    <SimpleWhiteBox style={{marginLeft:'auto', marginRight:'auto', maxWidth:'300px', padding: '20px 25px', 'borderRadius': '25px'}} content = {
      <form onSubmit={handleSearch} >
        <div className='row'>
          <TextField label="cerca una città" variant="standard" className="col-10" value={value} onChange={handleChangeValue} InputProps={{
            style:{color:'white'}
          }}
          />
          <IconButton aria-label="delete" type='submit' className="col-2">
            <SearchRoundedIcon />
          </IconButton>
        </div>
      </form>
    } />
  )
}